import { DATE_MASK, ZIP_CODE_MASK } from 'constants/forms'
import { getPurchaseDateOptions } from 'helpers/propertyHelpers'
import { OldSelectOwnProps } from 'components/atoms/inputs/OldSelectWrapped'
import createNumberMask from 'text-mask-addons/dist/createNumberMask'
import { formatCurrency, parseCurrency } from 'helpers/formHelpers'
import { DATE_FORMAT_US } from 'constants/datetime'
import { MAX_ACCOUNT_NUMBER_LENGTH, SEPARATED_NUMBER_REGEX, NO_DIGITS_REGEX, ROUTING_NUMBER_LENGTH } from 'constants/bounty'

// TODO @pmyagkov move this conversions to epic, leave form currency values stringy
export const FIELD_CURRENCY_WRAPPED_PROPS = {
  normalize: parseCurrency,
  format: formatCurrency,
}

export const FIELD_CONFIRM_PASSWORD_PROPS = {
  label: 'Confirm Password',
  type: 'password',
  qaMarker: 'confirm-password-input',
}

export const FIELD_USERNAME_PROPS = {
  label: 'Nickname',
  type: 'text',
  qaMarker: 'username-input',
}

export const FIELD_FIRST_NAME_PROPS = {
  label: 'First Name',
  type: 'text',
  qaMarker: 'first-name-input',
}

export const FIELD_LAST_NAME_PROPS = {
  label: 'Last Name',
  type: 'text',
  qaMarker: 'last-name-input',
}

export const FIELD_BIRTH_DATE_PROPS = {
  label: 'Date of Birth',
  type: 'tel',
  mask: DATE_MASK,
  placeholder: DATE_FORMAT_US,
  keepCharPositions: true,
  qaMarker: 'birth-date-input',
  qaType: 'tel',
}

const FIELD_ESTIMATED_PROPS = {
  label: 'Current Value',
  type: 'tel',
  qaType: 'tel',
  mask: createNumberMask({ prefix: '$' }),
  maxLength: 12,
}

export const FIELD_EMAIL_PROPS = {
  label: 'E-mail Address',
  type: 'email',
  qaMarker: 'email-input',
}

/* Homes */
export const FIELD_ADDRESS1_PROPS = {
  label: 'Address Line 1',
  type: 'text',
  placeholder: 'Street number, Street name',
  qaMarker: 'address1-input',
}

export const FIELD_ADDRESS2_PROPS = {
  label: 'Address Line 2',
  type: 'text',
  placeholder: 'Apartment number',
  qaMarker: 'address2-input',
}

export const FIELD_ZIP_PROPS = {
  label: 'Zip Code',
  type: 'tel',
  qaType: 'tel',
  mask: ZIP_CODE_MASK,
  qaMarker: 'zip-code-input',
}

export const FIELD_PURCHASED_PROPS = {
  label: 'Purchase Month/Year',
  options: getPurchaseDateOptions(),
} as OldSelectOwnProps<string>

export const FIELD_HOME_ESTIMATED_PROPS = {
  ...FIELD_ESTIMATED_PROPS,
  qaMarker: 'home-value-input',
}

export const FIELD_PRIMARY_RESIDENCE_PROPS = {
  label: 'Primary Residence',
  qaMarker: 'primary-residence-input',
}

/* Cars */
export const FIELD_CAR_ESTIMATED_PROPS = {
  ...FIELD_ESTIMATED_PROPS,
  qaMarker: 'car-value-input',
}

/* Bounty */
export const FIELD_REDEMPTION_AMOUNT_PROPS = {
  label: '',
  type: 'tel',
  qaMarker: 'redemption-amount',
  mask: createNumberMask({
    prefix: '$',
    thousandsSeparatorSymbol: '',
    integerLimit: 4,
    allowDecimal: true,
  }),
}

const createSeparatedNumberNormalize = (maxLength: number) => (rawValue: string, previousRawValue: string) => {
  if (!rawValue) {
    return rawValue
  }

  if (!SEPARATED_NUMBER_REGEX.test(rawValue) ||
    rawValue.includes('  ') ||
    rawValue.includes('--') ||
    rawValue.includes('- ') ||
    rawValue.includes(' -')) {
    return previousRawValue
  }

  const value = rawValue.replace(NO_DIGITS_REGEX, '')
  if (value.length > maxLength) {
    return previousRawValue
  }

  return rawValue
}

export const FIELD_ACCOUNT_NUMBER_WRAPPED_PROPS = {
  normalize: createSeparatedNumberNormalize(MAX_ACCOUNT_NUMBER_LENGTH),
}

export const FIELD_ACCOUNT_NUMBER_PROPS = {
  type: 'tel',
  label: 'Account Number',
  qaMarker: 'account-number',
  maxLength: MAX_ACCOUNT_NUMBER_LENGTH * 2,
}

export const FIELD_ROUTING_NUMBER_WRAPPED_PROPS = {
  normalize: createSeparatedNumberNormalize(ROUTING_NUMBER_LENGTH),
}

export const FIELD_ROUTING_NUMBER_PROPS = {
  type: 'tel',
  label: 'Routing Number',
  qaMarker: 'routing-number',
  maxLength: ROUTING_NUMBER_LENGTH * 2,
  hint: 'Your 9-digit Routing Number usually shown on the lower left corner of your checks.',
}
